import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../../shared/shared.module';
import { DataTableModule } from 'angular-datatables-all-versions';
import { SubscriptionsListComponent } from './subscriptions-list.component';
import { SubscriptionsListResolver } from './subscriptions-list.resolver';
import {AssociationsForFilterResolver} from '../../associations/associations-for-filter/associations-for-filter.resolver';
import { FilterSubscriptionsComponent } from './filter-subcriptions/filter-subscriptions.component';
import { BsDatepickerModule } from 'ngx-bootstrap';

@NgModule({
    imports: [
      NgbModule,
      SharedModule,
      DataTableModule,
      BsDatepickerModule
    ],
    declarations: [SubscriptionsListComponent, FilterSubscriptionsComponent],
    entryComponents: [FilterSubscriptionsComponent],
    exports: [SubscriptionsListComponent],
    providers: [SubscriptionsListResolver, AssociationsForFilterResolver]
  })
  export class SubscriptionsListModule {}
